import { hasPermission } from '@/hooks/useBackendMenu'
import { parseDataTransform, uploadFile } from '@acme/common'
import Dialog from 'global/guides/Dialog'
import { SubmitHandler } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { abonos, createAbonoRecorrenteSchema } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import { LancamentosAnterioresAsync } from 'templates/ManutencaoDoPonto/Ausencias/lancamentos-anteriores'
import { useUpdateDigitacaoQueryData } from 'templates/ManutencaoDoPonto/Digitacao/pages/useDigitacaoData'
import { z } from 'zod'
import { buildAbono } from '../../Ausencias/modals/AdicionarAbono'
import { REPETICAO_DEFAULT_VALUES } from '../atoms/RepeticaoAbonoAccordion'
import FormNovoAbono from '../forms/NovoAbono'
import { funcionarioPodeSolicitarAjustes } from './DetalhesRegistros'

const baseUrl = import.meta.env.VITE_BASE_URL

export default function NovoAbonoModal() {
    const { mutateAsync, isLoading } = abonos.mutations.useCreate()
    const { setQueryData } = useUpdateDigitacaoQueryData()
    const { dia } = useParams()

    const funcionarioId = useStore(state => state.employeeId)
    const empresaId = useStore(state => state.companyId)

    const handleSubmit: SubmitHandler<
        z.infer<typeof createAbonoRecorrenteSchema>
    > = async ({
        fileUrl,
        every,
        repeticaoMensalOpcao,
        tipoRepeticao,
        dataFinal,
        ...data
    }) => {
        const filename = await uploadFile(fileUrl!, baseUrl)

        const json = buildAbono(
            {
                ...parseDataTransform(data),
                funcionarioId: data.funcionarioId,
                empresaId,
                fileUrl: filename,
            },
            {
                every,
                repeticaoMensalOpcao,
                tipoRepeticao,
                dataFinal,
            },
        )

        await mutateAsync(json, {
            onSuccess: payload => {
                if (!Array.isArray(payload)) payload = [payload]
                for (const abono of payload) {
                    setQueryData('ABONO', abono)
                }
                toast.success('Abono adicionado com sucesso!')
            },
            onError: err => {
                toast.error(err.message)
            },
        })
    }

    return (
        <Dialog.Root
            height="auto"
            onSubmit={handleSubmit}
            loading={isLoading}
            defaultValues={{
                data: dia,
                tipo: 'NORMAL',
                funcionarioId: [funcionarioId].filter(v => v > 0),
                ...REPETICAO_DEFAULT_VALUES,
            }}
            schema={createAbonoRecorrenteSchema}
            open={
                hasPermission(['create', 'Abonos']) ||
                funcionarioPodeSolicitarAjustes()
            }
        >
            <Dialog.Title>Novo abono</Dialog.Title>
            <Dialog.Content dividers>
                <FormNovoAbono />
                <LancamentosAnterioresAsync tipoAusencia="Abono" />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
